import { render, staticRenderFns } from "./SupportTickets.vue?vue&type=template&id=a6d12a76"
import script from "./SupportTickets.vue?vue&type=script&lang=js"
export * from "./SupportTickets.vue?vue&type=script&lang=js"
import style0 from "./SupportTickets.vue?vue&type=style&index=0&id=a6d12a76&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports